This works despite the fact that IntelliJ is confused by the tag in the HTML,
and the import of the editable div ToDo: layout on phones - hide carousels, or
make the columns expand on small
<template>
  <div class="container" id="welcome">
    <div id="title" class="row">
      <div class="col">
        <h1>Welcome</h1>
        <p id="welcome-1">
          We absolutely adore the novels of Thomas Hardy written and set in
          England in the late 19th century.
          <br />
          We want to bring Hardy's stories to life and make them more accessible
          to modern audiences.
        </p>
      </div>
    </div>

    <div id="main" class="row">
      <div id="left-col" class="col-lg-4">
        <h2>Behind the scenes</h2>
        <hr-bts-gallery></hr-bts-gallery>
      </div>

      <div id="middle-col" class="col-lg-4 mainText">
        <div id="welcome-2">
          <p>
            We are a grassroots community project led by a local young Dorset
            film maker, Rose, who is working voluntarily with other amateurs to
            make one Hardy feature film and a couple of dramatic podcasts per
            year.
          </p>
          <p>
            <a
              class="donate-pill"
              href="https://donate.stripe.com/28oeXYb5K90R4mI3cc"
              target="_blank"
              rel="noopener noreferrer"
            >
              Donate to the Wessex Dramas Project
            </a>
          </p>
          <p>
            The Wessex Dramas Project shoots in Dorset, primarily at weekends,
            and welcomes everyone who wants to play as either cast, crew, or
            production team.
          </p>
          <p>
            We exhibit our films as public showings for free (unless as a
            charity fundraiser) with a free Q&amp;A session from the director:
            only expenses are asked for. We podcast our audio plays on this web
            site and other platforms.
          </p>
          <p>
            The project enters its films at international film festivals. It is
            is also not averse to approach from sponsors!
          </p>
        </div>
      </div>

      <div id="right-col" class="col-lg-4">
        <h2>This year's feature: "Fellow&nbsp;Townsmen"</h2>
        <img
          src="/wessex/features/fellow-townsmen/movie-poster@600h.jpg?v=3"
          alt="Poster for Hardy's Hand of Fate"
        />

        <div class="ratio ratio-16x9">
          <iframe
            src="https://www.youtube-nocookie.com/embed/MiYq0Zqsbpo"
            title="Trailer for The Well Beloved"
            allow="web-share"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useHead } from "@vueuse/head";
import HrBtsGallery from "@/components/btsGallery.vue";

useHead({
  title: "Welcome | Wessex Dramas",
  meta: [
    {
      name: "description",
      content:
        "Wessex Dramas brings Thomas Hardy’s stories to life through community-led films and podcasts in Dorset. Join us as cast, crew, or supporter!",
    },
  ],
  link: [{ rel: "canonical", href: "https://wessexdramas.org/" }],
});
</script>

<style lang="scss">
@use "@/assets/styles/livery" as *;

#welcome-1 {
  font-size: large;
  font-weight: 700;
}

#welcome-2 {
  font-size: large;
  margin-top: 3em;
}

#middle-col {
  text-align: center;
}

#right-col {
  img {
    width: 60%; // img-fluid makes it look crowded, with insufficient space on the right.
    margin-bottom: 1em; // because of the shadow under the image, give a bit of breathing space
  }

  .help {
    font-size: smaller;
    font-style: italic;
    color: $colour-banner-background;
    margin-top: 1em;
    margin-bottom: 0.25em;
  }
}

.donate-pill,
.donate-pill:link,
.donate-pill:visited,
.donate-pill:active {
  display: inline-block;
  padding: 1em;
  background-color: $colour-banner-background;
  color: $colour-banner-primary-text !important;
  border: none;
  border-radius: 999px; /* Makes it pill-shaped */
  font-size: 1.1em;

  font-family: branded-font, "Times New Roman", Times, serif;
  text-decoration: none;
  transition: background 0.2s;
  cursor: pointer;
}

.donate-pill:focus,
.donate-pill:hover {
  font-weight: bold;
}
</style>
